/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { JobApplicationStatus } from "./JobApplicationStatus";
import {
  JobApplicationStatusFromJSON,
  JobApplicationStatusFromJSONTyped,
  JobApplicationStatusToJSON,
  JobApplicationStatusToJSONTyped,
} from "./JobApplicationStatus";

/**
 * One logged stage change, shown as a row on the applicant's activity timeline.
 * @export
 * @interface ApplicationActivityDto
 */
export interface ApplicationActivityDto {
  /**
   *
   * @type {string}
   * @memberof ApplicationActivityDto
   */
  applicationActivityId: string;
  /**
   *
   * @type {string}
   * @memberof ApplicationActivityDto
   */
  actorEmail: string;
  /**
   *
   * @type {JobApplicationStatus}
   * @memberof ApplicationActivityDto
   */
  fromStatus: JobApplicationStatus;
  /**
   *
   * @type {JobApplicationStatus}
   * @memberof ApplicationActivityDto
   */
  toStatus: JobApplicationStatus;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof ApplicationActivityDto
   */
  createdAt: OffsetDateTime;
}

/**
 * Check if a given object implements the ApplicationActivityDto interface.
 */
export function instanceOfApplicationActivityDto(
  value: object,
): value is ApplicationActivityDto {
  if (
    !("applicationActivityId" in value) ||
    value["applicationActivityId"] === undefined
  )
    return false;
  if (!("actorEmail" in value) || value["actorEmail"] === undefined)
    return false;
  if (!("fromStatus" in value) || value["fromStatus"] === undefined)
    return false;
  if (!("toStatus" in value) || value["toStatus"] === undefined) return false;
  if (!("createdAt" in value) || value["createdAt"] === undefined) return false;
  return true;
}

export function ApplicationActivityDtoFromJSON(
  json: any,
): ApplicationActivityDto {
  return ApplicationActivityDtoFromJSONTyped(json, false);
}

export function ApplicationActivityDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApplicationActivityDto {
  if (json == null) {
    return json;
  }
  return {
    applicationActivityId: json["applicationActivityId"],
    actorEmail: json["actorEmail"],
    fromStatus: JobApplicationStatusFromJSON(json["fromStatus"]),
    toStatus: JobApplicationStatusFromJSON(json["toStatus"]),
    createdAt: json["createdAt"],
  };
}

export function ApplicationActivityDtoToJSON(
  json: any,
): ApplicationActivityDto {
  return ApplicationActivityDtoToJSONTyped(json, false);
}

export function ApplicationActivityDtoToJSONTyped(
  value?: ApplicationActivityDto | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    applicationActivityId: value["applicationActivityId"],
    actorEmail: value["actorEmail"],
    fromStatus: JobApplicationStatusToJSON(value["fromStatus"]),
    toStatus: JobApplicationStatusToJSON(value["toStatus"]),
    createdAt: value["createdAt"],
  };
}
